import React, { useState, useEffect } from "react";
import VSBarChart from "../Graphs/V_StatisticsGraph/VS_BarChart";
import VSHeatMapChart from "../Graphs/V_StatisticsGraph/VS_HeatMapChart";
import VSTopLeader from "../Graphs/V_StatisticsGraph/VS_TopLeader";
import VSTopSales from "../Graphs/V_StatisticsGraph/VS_TopSales";
import { OrderTradeStates, VolumeStateOptions } from "../utlits";
import { DownloadReportsTypes } from "../../../../Containers/vendor/DashBoard/DBCosntants";

export interface IVolStatisticsProps {
  dbData: any;
  downloadDbReports: (rpTyp: string) => void;
}

const VolStatistics: React.FC<IVolStatisticsProps> = (props) => {
  const [dropdownValue, setDropdownValue] = useState<string | number>(
    VolumeStateOptions[0].value
  );
  const [leadersdropdownValue, setLeadersdropdownValue] =
    React.useState<string>("Total");

  const [rowHeatmapData, setRowHeatmapData] = useState<any>([]);
  const [rowStateData, setRowStateData] = useState<any>([]);
  const [topLeaders, setTopLeaders] = useState<any>([]);

  const handleDownloadBtn = () => {
    let rpTyp =
      dropdownValue === OrderTradeStates.ORDER
        ? DownloadReportsTypes.Order
        : DownloadReportsTypes.Trade;
    props.downloadDbReports(rpTyp);
  };

  useEffect(() => {
    if (props.dbData && dropdownValue) {
      if (
        dropdownValue === OrderTradeStates.ORDER &&
        (props.dbData.ordVolHtMap || props.dbData.ordVolStats)
      ) {
        setRowStateData(props.dbData.ordVolStats);
        setRowHeatmapData(props.dbData.ordVolHtMap);
      } else if (
        dropdownValue === OrderTradeStates.TRADE &&
        (props.dbData.trdVolHtMap || props.dbData.trdVolStats)
      ) {
        setRowStateData(props.dbData.trdVolStats);
        setRowHeatmapData(props.dbData.trdVolHtMap);
      }
    } else {
      setRowStateData([]);
      setRowHeatmapData([]);
    }
  }, [props.dbData, dropdownValue]);

  useEffect(() => {
    if (props.dbData && leadersdropdownValue) {
      let getTopLdrsSegwise = props.dbData.volumeLdrsSegWise.filter(
        (leader: any) => {
          return leadersdropdownValue === leader.sortBsdOn;
        }
      );
      if (getTopLdrsSegwise.length > 0) {
        setTopLeaders(getTopLdrsSegwise[0].leadrs);
      }
    } else {
      setTopLeaders([]);
    }
  }, [props.dbData, leadersdropdownValue]);

  return (
    <div className="v_Statistics">
      <div className="v_Statistics_row_one">
        <div className="Graph_col v_Statistics_col_one">
          <VSBarChart
            rowStateData={rowStateData}
            dropdownValue={dropdownValue}
            setDropdownValue={setDropdownValue}
          />
        </div>
        <div className="Graph_col v_Statistics_col_tow">
          <VSHeatMapChart
            rowHeatmapData={rowHeatmapData}
            handleDownloadBtn={handleDownloadBtn}
          />
        </div>
      </div>
      <div className="v_Statistics_row_two top_leaders_container">
        <div className="Graph_col v_Statistics_col_three">
          <VSTopLeader
            leadersdropdownValue={leadersdropdownValue}
            setLeadersdropdownValue={setLeadersdropdownValue}
            topLeaders={topLeaders}
          />
        </div>
        <div className="Graph_col v_Statistics_col_four">
          <VSTopSales dbData={props.dbData} />
        </div>
      </div>
    </div>
  );
};

export default VolStatistics;
